import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription, throwError } from 'rxjs';
import { catchError, filter, finalize, map, share, switchMap, takeUntil, tap } from 'rxjs/operators';
import { RoutesService } from 'src/app/shared/services/routes/routes.service';
import { DateService } from 'src/app/shared/services/utilities/date.service';
import { ObservableProperty } from 'src/app/utils/decorators/observable-property.decorator';
import { KzIconsRegistryService } from 'src/app/kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsArrowleft } from 'src/app/kz-ui/ui/icon/generated-icons/kzIcons-arrowleft.icon';
import { kzIconsArrowright } from 'src/app/kz-ui/ui/icon/generated-icons/kzIcons-arrowright.icon';
import { AuthPopinService } from 'src/app/modules/auth/auth-popin.service';
import { ToastrService } from 'src/app/shared/services/utilities/toastr.service';
import { AuthService } from 'src/app/modules/auth/auth.service';
import {
  AuthenticationService as SDKAuthenticationService,
  Kaza,
  ProjectType,
  KazaService as SDKKazaService,
  ProjectTypeService as SDKProjectTypes
} from '@adeo/ngx-kozikaza-api';
import { KazaService as LegacyKazaService } from 'src/app/shared/services/features/kaza/kaza.service';
import { UserStoreService } from 'src/app/shared/services/state-management/user-store.service';
import { getTranslation } from 'src/app/utils/const/translation';
interface DateObject {
  label: string;
  i18n?: string;
  requalificationLabel?:string;
  constructionStartedAt: Date;
  constructionEndedAt?: Date;
}
enum RequalificationLabel {
  AS_SOON_AS_POSSIBLE='AS_SOON_AS_POSSIBLE',
  LESS_THAN_THREE_MONTHS = 'LESS_THAN_THREE_MONTHS',
  LESS_THAN_SIX_MONTHS = 'LESS_THAN_SIX_MONTHS',
  LESS_THAN_TWELVE_MONTHS = 'LESS_THAN_TWELVE_MONTHS',
  LESS_THAN_TWENTY_FOUR_MONTHS = 'LESS_THAN_TWENTY_FOUR_MONTHS',
}

@Component({
  selector: 'app-construction-date',
  templateUrl: './construction-date.component.html',
  styleUrls: ['./construction-date.component.scss']
})
export class ConstructionDateComponent implements OnInit, OnDestroy{
  isInKazaplan$: Observable<boolean> = this.routesService.routeDatas.pipe(
    map((data) => !!data.isKazaplanRoute),
    share(),
  );
  destroyed$: Subject<boolean> = new Subject()
  @ObservableProperty(null)
  startDate: Date;
  public startDate$: BehaviorSubject<Date>;
  dateSelected: Date;
  dates: Date[] = [];
  groupedDates: any;
  sub: Subscription;
  kazaPutSub: Subscription;
  kazaSub: Subscription;
  subProjectTypes: Subscription;
  projectTypes: ProjectType[];
  loadingProjectTypes = true;
  kaza: any; // toDo with ngx-kozikaza-api
  submitted = false;
  newDates:Array<{'label':string,'constructionStartedAt':Date,'constructionEndedAt'?:Date}> = [];
  justStartDate:Array<{'label':string,'constructionStartedAt':Date}> = [];
  relatifProjectDate:Array<{'label':string,'value':string}>
  projectType:string;
  showExtraStartingDates= false;
  isRelatifProject:boolean;
  isSellRelatifProject:boolean;
  selectedRelatifDate:string;
  selectedIsSellRelatifDate:string;
  isRenovationOrconstruction = false;
  isUnknownDate = false ;
  constructionDatesAlreadyAnswered:boolean;
  selectedRequalificationLabel:string;
  
  constructor(
    private readonly routesService: RoutesService,
    private readonly dateService: DateService,
    private readonly kzIconsRegistryService: KzIconsRegistryService,
    private cdr: ChangeDetectorRef,
    private authPopinService: AuthPopinService,
    private readonly sdkProjectTypesService: SDKProjectTypes,
    private toastr: ToastrService,
    private legacyKazaService: LegacyKazaService,
    private authService: AuthService,
    private sdkKazaService: SDKKazaService,
    private userStoreService: UserStoreService
  ) {
  }

  ngOnInit(): void {
    this.loadKaza();
    this.loadProjectTypes();
    this.kzIconsRegistryService.registerIcons([kzIconsArrowleft, kzIconsArrowright]);
    this.startDate = this.dateService.startOfYear();
    this.sub = this.startDate$.pipe(
      tap((date: Date) => {
        this.dates = [];
        this.dates.push(date);
        for(let i = 1; i < 24; i++) {
          this.dates.push(this.dateService.addMonths(i, date));
        }

        this.groupedDates = this.dates.reduce((accumulator, currentDate) => {
          const currentYear = currentDate.getFullYear();

          if (!accumulator[currentYear]) {
            accumulator[currentYear] = [];
          }

          accumulator[currentYear].push(currentDate);

          return accumulator;
        }, {});
        this.cdr.markForCheck();
      })
    ).subscribe();
    this.initRelatifProjectDate();
    this.getProjectIsAlreadyBegunStatus();
    this.createDateObjects();
  }
 
  prev(): void {
    this.startDate = this.dateService.subYears(1, this.startDate);
  }
  next(): void {
    this.startDate = this.dateService.addYears(1, this.startDate);
  }

  private loadProjectTypes(): void {
    this.subProjectTypes = this.sdkProjectTypesService.getProjectTypes(null).pipe(
      catchError((e) => {
        this.toastr.error($localize`:@@toast.error_try_again:An error has occurred. Please try again`);
        return throwError(e);
      }),
      finalize(() => this.loadingProjectTypes = false),
      tap((data) => {
        this.projectTypes = data['hydra:member'];
        this.getProjectTypes(this.kaza?.types)
       
      })
    ).subscribe();
  }

  private loadKaza(): void {
    this.kazaSub = this.userStoreService.userStore.pipe(
      filter((user) => !!user),
      switchMap((user) => {
        return this.sdkKazaService.getKaza(user.activeKaza, ['types']).pipe(
          catchError((e) => {
            this.toastr.error($localize`:@@toast.error_try_again:An error has occurred. Please try again`);
            return throwError(e);
          }),
          tap((kaza:any) =>{ // toDo with ngx-kozikaza-api 
            this.kaza = kaza;
            // check I have already started case
              this.dateSelected = kaza?.constructionStartedAt;
              if(kaza?.constructionDatesAlreadyAnswered){
                this.isSellRelatifProject =   kaza?.propertySale;
                this.isRelatifProject =   kaza?.propertyRental;
              }
              this.selectedIsSellRelatifDate = kaza?.propertySaleTemporality;
              this.selectedRelatifDate = kaza?.propertyRentalTemporality;
              this.isUnknownDate =  kaza?.constructionStartedAt == null
              this.constructionDatesAlreadyAnswered = kaza?.constructionStartedAt &&  !kaza.constructionDatesAlreadyAnswered      
              this.selectedRequalificationLabel = this.requalificationProjectEvreyThreeMonths(kaza);
            
            }
         )
        );
      })
    ).subscribe();
  }

  nextStep(kaza: Kaza): void {
    let types = kaza.types;
    types = types.map((type) => {
      const typeMapped = this.projectTypes.find((projectType) => projectType['@id'] === ((typeof type === 'string') ? type : type['@id']));
      return typeMapped.type;
    });
    if (types.includes('construction') || types.includes('no-work')) {
      this.close();
    } else if (types.includes('renovation') || types.includes('extension') || types.includes('energetic-renovation')) {
      this.authService.redirectToTags(1);
    } else if (types.includes('arrangement') || types.includes('garden')) {
      this.authService.redirectToTags(2);
    }
  }

  save(skip = false): void {
    this.submitted = true;
    const requestBody = {
      constructionStartedAt: (this.isUnknownDate) ? null : this.dateSelected,
      constructionDatesAlreadyAnswered: true,
      propertySale: this.isSellRelatifProject,
      propertyRental: this.isRelatifProject,
    };
    
    if (this.isSellRelatifProject) {
      requestBody['propertySaleTemporality'] = this.selectedIsSellRelatifDate;
    }
    
    if (this.isRelatifProject) {
      requestBody['propertyRentalTemporality'] = this.selectedRelatifDate;
    }
    
    this.kazaSub = this.legacyKazaService.update(this.kaza['@id'],requestBody).pipe(
      finalize(() => this.submitted = false),
      catchError((e) => {
        this.toastr.error($localize`:@@toast.error_try_again:An error has occurred. Please try again`);
        return throwError(e);
      }),
      tap((kazaUpdated: Kaza) =>{
        this.userStoreService.previousAuthTagsEnabled = false;
        this.nextStep(kazaUpdated);
      } )
    ).subscribe();
  }
  dateTrackBy(index, value): Date{
    return value;
  }

  close(): void {
    this.authPopinService.closePopinAndRedirect();
  }
  private addDateObject(label: string, monthsOffset: number,isDays = false, baseDate: Date = new Date(), requalificationLabel?:string): DateObject {
    return {
      label,
      requalificationLabel,
      constructionStartedAt: isDays?this.dateService.addDays(monthsOffset, baseDate):this.dateService.addMonths(monthsOffset, baseDate),
    };
  }
  
  private createDateObjects(): void {
      this.newDates = [
        this.addDateObject(getTranslation('auth.construction-date.asSoonAsPossible'), 1,true,new Date(),RequalificationLabel.AS_SOON_AS_POSSIBLE),
        this.addDateObject(getTranslation('auth.construction-date.lessThanThreeMonths'), 1,false, new Date(),RequalificationLabel.LESS_THAN_THREE_MONTHS),
        this.addDateObject(getTranslation('auth.construction-date.lessThanSixMonths'), 3,false, new Date(),RequalificationLabel.LESS_THAN_SIX_MONTHS),
        this.addDateObject(getTranslation('auth.construction-date.lessThanTweleveMonths'), 6,false, new Date(),RequalificationLabel.LESS_THAN_TWELVE_MONTHS),
        this.addDateObject(getTranslation('auth.construction-date.lessThanTwentyFourMonths'), 12,false, new Date(),RequalificationLabel.LESS_THAN_TWENTY_FOUR_MONTHS),
      ];

  }

  
  public showStartingDates(): void {
    this.showExtraStartingDates = !this.showExtraStartingDates;
    this.userStoreService.projectIsAlreadyBegun = this.showExtraStartingDates;
    this.isUnknownDate = false;
    this.dateSelected = null;
    if (this.showExtraStartingDates) {
      this.initExtraDatesProject()
    }
  }
  private getProjectTypes(types){
    this.projectType = types?.map((type) => {
      const typeMapped = this.projectTypes.find((projectType) => projectType['@id'] === ((typeof type === 'string') ? type : type['@id']));
      return typeMapped?.type;
    });
    this.isRenovationOrconstruction = this.projectType.includes('renovation') || this.projectType.includes('construction')
    this.cdr.detectChanges();
  }
  private initRelatifProjectDate():void {
    this.relatifProjectDate = [
    {label:getTranslation('auth.relatif-project.soon') ,value:'soon',},
    {label:getTranslation('auth.relatif-project.inProgress'),value:'in_progress'},
    {label:getTranslation('auth.relatif-project.completedInSixmonths') ,value:'last_six_months'},
    {label:getTranslation('auth.relatif-project.none') ,value:'none'}]
  }
  private initExtraDatesProject():void {
    this.justStartDate = [
      this.addDateObject(getTranslation('auth.construction-date.lessThanThreeMonths') ,-3 ),
      this.addDateObject(getTranslation('auth.construction-date.lessThanSixMonths'), -6 ),
      this.addDateObject(getTranslation('auth.construction-date.lessThanTweleveMonths'), -12),
    ];
  }
  public selectDate(date):void {
    this.dateSelected = date?.constructionStartedAt;
    this.showExtraStartingDates = false; 
    this.userStoreService.projectIsAlreadyBegun = false;
    this.isUnknownDate = false
    this.selectedRequalificationLabel = null;
  }
  private getProjectIsAlreadyBegunStatus():void {
    this.userStoreService.getprojectIsAlreadyBegun().pipe(takeUntil(this.destroyed$)).subscribe({
      next:data=> {
        if(data){
          this.showExtraStartingDates = data;
          this.initExtraDatesProject();
        }
      }
    })
  }
  selectUnknownStartDate():void {
    this.isUnknownDate = true;
    this.dateSelected = null;
    this.userStoreService.projectIsAlreadyBegun = false;
    this.showExtraStartingDates = false;
    this.selectedRequalificationLabel = null;
  }
  private requalificationProjectEvreyThreeMonths(kaza:Kaza):string {
   if(!kaza?.constructionDatesAlreadyAnswered && kaza.constructionStartedAt){
    const today = new Date();
    // Calculate the difference in months
    const diffInMonths = Math.abs((today.getFullYear() - kaza.constructionStartedAt.getFullYear()) * 12 +
                         today.getMonth() - kaza.constructionStartedAt.getMonth());
    // Determine the label based on the difference
    if (diffInMonths >= 0 && diffInMonths <= 3) {
        return RequalificationLabel.LESS_THAN_THREE_MONTHS;
    } else if (diffInMonths > 3 && diffInMonths <= 6) {
        return RequalificationLabel.LESS_THAN_SIX_MONTHS;
    } else if (diffInMonths > 6 && diffInMonths <= 12) {
        return RequalificationLabel.LESS_THAN_TWELVE_MONTHS;
   /* } else if (diffInMonths > 12 && diffInMonths <= 24) {
        return RequalificationLabel?.LESS_THAN_TWENTY_FOUR_MONTHS;
    } */
    } else {
        return RequalificationLabel.LESS_THAN_TWENTY_FOUR_MONTHS; 
    }
  }
  }
  ngOnDestroy(): void {
    if (this.sub && !this.sub.closed) {
      this.sub.unsubscribe();
    }

    if (this.kazaSub && !this.kazaSub.closed) {
      this.kazaSub.unsubscribe();
    }

    if (this.kazaPutSub && !this.kazaPutSub.closed) {
      this.kazaPutSub.unsubscribe();
    }

    if (this.subProjectTypes && !this.subProjectTypes.closed) {
      this.subProjectTypes.unsubscribe();
    }
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}